import { render, staticRenderFns } from "./BlocoFiltrosPrincipais.vue?vue&type=template&id=1cae2be0&scoped=true"
import script from "./BlocoFiltrosPrincipais.vue?vue&type=script&lang=js"
export * from "./BlocoFiltrosPrincipais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae2be0",
  null
  
)

export default component.exports